'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _index = require('./../index');

var _reduxForm = require('redux-form');

var _SubjektRow = require('./SubjektRow');

var _SubjektRow2 = _interopRequireDefault(_SubjektRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubjektAddSelectRegForm = function (_React$Component) {
    (0, _inherits3.default)(SubjektAddSelectRegForm, _React$Component);

    function SubjektAddSelectRegForm() {
        (0, _classCallCheck3.default)(this, SubjektAddSelectRegForm);
        return (0, _possibleConstructorReturn3.default)(this, (SubjektAddSelectRegForm.__proto__ || (0, _getPrototypeOf2.default)(SubjektAddSelectRegForm)).apply(this, arguments));
    }

    (0, _createClass3.default)(SubjektAddSelectRegForm, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                subjekt = _props.subjekt,
                onClose = _props.onClose,
                handleSubmit = _props.handleSubmit,
                overeniResultList = _props.overeniResultList;


            return _react2.default.createElement(
                _index.form.Form,
                { onSubmit: handleSubmit, horizontal: true },
                _react2.default.createElement(
                    _index.form.FormBody,
                    null,
                    _react2.default.createElement(_index.ff.ListSelect, {
                        name: 'subjekt',
                        field: false,
                        idAttrName: 'overeniId',
                        renderItem: function renderItem(x) {
                            return _react2.default.createElement(_SubjektRow2.default, { subjekt: x.subjekt, zastupce: x.subjekt.zastupce });
                        },
                        items: overeniResultList
                    })
                ),
                _react2.default.createElement(_index.form.FormActions, { submitButton: 'Vybrat', cancelButton: true, submitDisabled: !subjekt, onClose: onClose })
            );
        }
    }]);
    return SubjektAddSelectRegForm;
}(_react2.default.Component); /**
                               * FormuLář vybrání jednoho subjektu z více, které byly na základě vyhledávání vráceny ze ZR.
                               */


SubjektAddSelectRegForm.formName = 'subjektAddSelectRegForm';
SubjektAddSelectRegForm.PropTypes = {
    //overeniResultList
};
SubjektAddSelectRegForm.defaultProps = {};


var reduxSubjektForm = (0, _reduxForm.reduxForm)({
    form: SubjektAddSelectRegForm.formName
})(SubjektAddSelectRegForm);

function mapStateToProps(state, props) {
    var selector = (0, _reduxForm.formValueSelector)(SubjektAddSelectRegForm.formName);
    return {
        subjekt: selector(state, "subjekt")
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(reduxSubjektForm);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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